// extracted by mini-css-extract-plugin
export default {"root":"Back_root__3Jyte","back":"Back_back__1m9j-"};